import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';

import ManufacturerBox from '../../layout-box/ManufacturerBox';
import { modelOf } from '../../../prop-types';
import LayoutBoxStore from '../../../store/LayoutBoxStore';
import UIStore from '../../../store/UIStore';

@observer
export class NavigationManufacturerBox extends Component {
  getManufacturerBoxTitle = () => {
    const { layoutBoxStore } = this.props;
    const layoutBoxes = layoutBoxStore.layoutBoxes;
    if (layoutBoxes && layoutBoxes.length) {
      const manufacturerBox = layoutBoxes.find(
        (layoutBox) => layoutBox.key === 'manufacturers'
      );
      return manufacturerBox.title;
    }
  };

  closeMegaMenu = () => {
    const { uiStore } = this.props;

    return uiStore.megaMenu.close();
  };

  getManufacturers = (manufacturers) => {
    const { onManufacturersUpdate } = this.props;
    onManufacturersUpdate(manufacturers);
  };

  render() {
    const title = this.getManufacturerBoxTitle();

    return (
      <ManufacturerBox
        className="ManufacturerBox__two-level-megamenu"
        twoLayerMegamenuEnabled
        title={title}
        minManufacturersForDropdown={5}
        onLinkClick={this.closeMegaMenu}
        linkButtonClassName="NavigationManufacturerBox__link-button"
        onManufacturersUpdate={this.getManufacturers}
      />
    );
  }
}

NavigationManufacturerBox.propTypes = {
  layoutBoxStore: modelOf(LayoutBoxStore).isRequired,
  uiStore: modelOf(UIStore).isRequired,
  onManufacturersUpdate: PropTypes.func.isRequired
};

export default inject('layoutBoxStore', 'uiStore')(NavigationManufacturerBox);



// WEBPACK FOOTER //
// ./src/components/navigation/NavigationManufacturerBox/index.jsx